// extracted by mini-css-extract-plugin
export default {"card":"c1-z","carouselContainer":"d1-z","carouselContent":"e1-z"};